import { z } from 'zod'
import { asEnumType } from '@gqloom/zod'

export const userTypeSchema = z.enum(['admin', 'staff', 'client', 'api']).register(asEnumType, {
  name: 'UserType',
  description: 'Type of user (api type is for REST API key authenticated requests)',
})

export type UserType = z.infer<typeof userTypeSchema>
